import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PremiumExpiryBanner from "@/components/PremiumExpiryBanner";
import BetaFeedback from "@/components/BetaFeedback";
import CookieConsent from "@/components/CookieConsent";
import OfferTray from "@/components/OfferTray";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <PremiumExpiryBanner />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <OfferTray />
      <BetaFeedback />
      <CookieConsent />
    </div>
  );
}
